"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var applyInlineStyle_1 = require("../utils/applyInlineStyle");
/**
 * Set background color at current selection
 * @param editor The editor instance
 * @param color One of two options:
 * The color string, can be any of the predefined color names (e.g, 'red')
 * or hexadecimal color string (e.g, '#FF0000') or rgb value (e.g, 'rgb(255, 0, 0)') supported by browser.
 * Currently there's no validation to the string, if the passed string is invalid, it won't take affect
 * Alternatively, you can pass a @typedef ModeIndepenentColor. If in light mode, the lightModeColor property will be used.
 * If in dark mode, the darkModeColor will be used and the lightModeColor will be used when converting back to light mode.
 **/
function setBackgroundColor(editor, color) {
    if (typeof color === 'string') {
        var trimmedColor_1 = color.trim();
        applyInlineStyle_1.default(editor, function (element, isInnerNode) {
            element.style.backgroundColor = isInnerNode ? '' : trimmedColor_1;
        });
    }
    else {
        var darkMode_1 = editor.isDarkMode();
        var appliedColor_1 = darkMode_1 ? color.darkModeColor : color.lightModeColor;
        applyInlineStyle_1.default(editor, function (element, isInnerNode) {
            element.style.backgroundColor = isInnerNode ? '' : appliedColor_1;
            if (darkMode_1) {
                element.dataset.ogsb = color.lightModeColor;
            }
        });
    }
}
exports.default = setBackgroundColor;
//# sourceMappingURL=setBackgroundColor.js.map